/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Gyms_Use_LabelInputs */

const en_us2_gyms_use_label = /** @type {(inputs: Gyms_Use_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Use ${i?.name}`)
};

const pt_br2_gyms_use_label = /** @type {(inputs: Gyms_Use_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usar ${i?.name}`)
};

const es_419_gyms_use_label = /** @type {(inputs: Gyms_Use_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usar ${i?.name}`)
};

const pt_pt2_gyms_use_label = /** @type {(inputs: Gyms_Use_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usar ${i?.name}`)
};

const fr_fr2_gyms_use_label = /** @type {(inputs: Gyms_Use_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Utiliser ${i?.name}`)
};

const de_de2_gyms_use_label = /** @type {(inputs: Gyms_Use_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} nutzen`)
};

const it_it2_gyms_use_label = /** @type {(inputs: Gyms_Use_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usa ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Use {name}" |
*
* @param {Gyms_Use_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_use_label = /** @type {((inputs: Gyms_Use_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_Use_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_use_label(inputs)
	if (locale === "es-419") return es_419_gyms_use_label(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_use_label(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_use_label(inputs)
	if (locale === "de-DE") return de_de2_gyms_use_label(inputs)
	if (locale === "it-IT") return it_it2_gyms_use_label(inputs)
	return en_us2_gyms_use_label(inputs)
});
export { gyms_use_label as "gyms.use_label" }